<h1 mat-dialog-title>Choose dosage type and package types</h1>
<div mat-dialog-content>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Choose dosage type</mat-label>
      <mat-select required (selectionChange)="getPackageTypes($event.value)" [(ngModel)]="data.dosageTypeId">
        @for (type of dosageTypes; track type) {
          <mat-option value="{{type.id}}">
            {{type.additional_information}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Add packages</mat-label>
      <mat-chip-grid #chipList aria-label="Package type selection">
        @for (packageType of selectedPackageTypes; track packageType) {
          <mat-chip-row (removed)='removePackageType(packageType.id)'>
            {{packageType.type}}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input required #packageTypeInput [formControl]="packageTypesCtrl" placeholder="Add package type" [matAutocomplete]="auto" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addPackageType($event)">
      </mat-chip-grid>
      <mat-autocomplete (optionSelected)="selectPackageType($event)" #auto="matAutocomplete">
        @for (type of filteredPackageTypes | async; track type) {
          <mat-option [value]="type">
            {{type.type}}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button color='primary' mat-raised-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
</div>